@if (animationsDaten()) {
  <ng-lottie
    [options]="options()"
    [width]="width() ?? size()"
    [height]="height() ?? size()"
    (animationCreated)="uebernehmeEinstellungen($event)"
  ></ng-lottie>
} @else {
  <!-- `ng-lottie` ohne Animationsdaten haette nichts abzuspielen. Bis sie da sind, haelt ein leerer
       Kasten derselben Groesse den Platz — ohne ihn ruckt der Inhalt darunter beim ersten Aufruf. -->
  <div class="platzhalter" [style.width]="width() ?? size()" [style.height]="height() ?? size()" aria-hidden="true"></div>
}
